import type { EditAreaTemplateApplication } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { Button } from '@/shared/ui';

interface TemplateAppliedNoticeProps {
  readonly application: EditAreaTemplateApplication;
  readonly sourceLabel: string;
  readonly onDismiss: () => void;
}

/** 적용·복사 뒤 다음 할 일 — 색상별 목업 업로드(원통은 마스크 포함) → 저장. 상품에 바뀐 점도 함께 알린다. */
export const TemplateAppliedNotice = ({
  application,
  sourceLabel,
  onDismiss,
}: TemplateAppliedNoticeProps): ReactElement => {
  const { linked } = application;
  const linkedParts = [
    linked.fonts > 0 ? `폰트 ${linked.fonts}개` : null,
    linked.inkColors > 0 ? `잉크 색상 ${linked.inkColors}개` : null,
    linked.printMethods > 0 ? `인쇄 방식 ${linked.printMethods}개` : null,
  ].filter((part) => part !== null);
  return (
    <div
      role="status"
      className="space-y-1 rounded-lg border border-primary/40 bg-primary/5 p-4 text-sm"
    >
      <p className="font-medium">{sourceLabel} 의 편집영역을 가져왔습니다 (아직 저장 전).</p>
      <p>
        다음: 아래{' '}
        <a href="#edit-area-photos" className="underline">
          상품 목업 이미지
        </a>
        에서 색상 × 면마다 목업 사진을 올리고
        {application.measurementKind === 'CYLINDER'
          ? ', 원통 면에는 몸통 마스크(머그는 손잡이 제외)도 올린 뒤'
          : ''}{' '}
        [편집영역 저장]을 누르세요.
      </p>
      {application.scaled ? (
        <p>상품 실측이 템플릿과 달라 인쇄 영역·배치를 비율로 맞췄습니다. 크기를 확인해 주세요.</p>
      ) : null}
      {application.measurementKindChanged ? (
        <p>상품 실측 종류를 템플릿에 맞춰 바꿨습니다.</p>
      ) : null}
      {linkedParts.length > 0 ? (
        <p>비어 있던 허용 항목을 가져온 기본값으로 연결했습니다: {linkedParts.join(', ')}.</p>
      ) : null}
      <Button type="button" size="sm" variant="ghost" onClick={onDismiss}>
        닫기
      </Button>
    </div>
  );
};
